import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

export const useStyles = (isDisabled?: boolean, showSeparator?: boolean) =>
  ({
    toggleItemContainer: {
      display: "flex",
      alignItems: "center",
      padding: showSeparator ? "0 0 16px 0" : "16px 0",
      justifyContent: "space-between"
    },
    toggleItemTitleBox: {
      display: "flex",
      alignItems: "center",
      color: isDisabled ? colors.textDisabled : colors.textSecondary
    },
    titleTypography: {
      display: "inline",
      color: isDisabled ? colors.textDisabled : colors.textSecondary
    },
    tooltipSpan: {
      display: "inline-flex",
      verticalAlign: "middle",
      marginLeft: "4px"
    }
  }) as CSSObject;
